// src/pages/account/AboutPage.jsx
import AboutPanel from "./AboutPanel";

export default function AboutPage() {
  return <AboutPanel />;
}
